export default __webpack_public_path__ + "static/icon-29-2-4b5f512c1a3a4705089e89eac535d8bb.png";